import { render, staticRenderFns } from "./thesisInfo.vue?vue&type=template&id=67cce198&scoped=true&"
import script from "./thesisInfo.vue?vue&type=script&lang=js&"
export * from "./thesisInfo.vue?vue&type=script&lang=js&"
import style0 from "./thesisInfo.vue?vue&type=style&index=0&id=67cce198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cce198",
  null
  
)

export default component.exports